import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useForm, ValidationError } from '@formspree/react';
import image2 from '../../images/nasirul01.png';
import './Contact.css';
import Success from './Success';

function ContactForm() {
    const [state, handleSubmit] = useForm("meqnjljl");
    if (state.succeeded) {
        return <>
            <Success />
        </>;
    }
    return (
        <div className="contact" id="Contact">
            <Container className="pt-5">
                <Row className="g-4">
                    <Col sm={12} md={6} lg={6}>
                        <div className="text-start">
                            <h1 className="text-white my-4">
                                Hire Me.
                            </h1>
                            <p>I am available for work. Connect with me via phone: <br /> <span className="text-white">01794170777</span> or email: <span className="text-white">nasirulislam866@gmail.com</span></p>
                        </div>
                        <div className="contactform w-100">
                            <form onSubmit={handleSubmit}>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Your name"
                                />
                                <br />
                                <ValidationError
                                    prefix="Name"
                                    field="name"
                                    errors={state.errors}
                                />
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Enter your email"
                                />
                                <br />
                                <ValidationError
                                    prefix="Email"
                                    field="email"
                                    errors={state.errors}
                                />
                                <input
                                    type="text"
                                    name="subject"
                                    placeholder="Subject"
                                />
                                <br />
                                <ValidationError
                                    prefix="Subject"
                                    field="subject"
                                    errors={state.errors}
                                />
                                <textarea
                                    className="my-2"
                                    id="message"
                                    name="message"
                                    placeholder="Enter your message"
                                />
                                <br />
                                <ValidationError
                                    prefix="Message"
                                    field="message"
                                    errors={state.errors}
                                />
                                <Button type="submit"
                                    disabled={state.submitting}
                                    variant="info"
                                    className="fw-bold fs-5 px-5 text-white">
                                    SUBMIT
                                </Button>
                            </form>
                        </div>
                    </Col>
                    <Col sm={12} md={6} lg={6}>
                        <div className="photo">
                            <img width="100%" src={image2} alt="my_image" />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ContactForm;